import { forwardRef } from 'react';
import { Button } from '@mui/material';
import { IContainedButton } from 'types/atoms';

const CContainedPrimaryButton = forwardRef<HTMLButtonElement, IContainedButton>((props, ref) => {
  return (
    <Button
      {...props}
      ref={ref}
      variant="contained"
      classes={{
        root: 'rounded-xl bg-primary-300 text-label16 normal-case hover:bg-primary-300 disabled:bg-neutral-200',
        startIcon: 'mx-0 [&>*:nth-of-type(1)]:text-xl',
        endIcon: 'mx-0 [&>*:nth-of-type(1)]:text-xl',
        containedSizeSmall: '',
        containedSizeMedium: 'h-[44px]',
        containedSizeLarge: 'h-[52px]',
        // TODO: focus color when disabled
      }}
    />
  );
});

export default CContainedPrimaryButton;

